import { deepMerge } from "./auth-service-tools169.js";
import "react";
import "./auth-service-tools177.js";
import { defaultCssVariablesResolver } from "./auth-service-tools229.js";

function getMergedVariables(_ref) {
  let {
    theme,
    generator
  } = _ref;
  const defaultResolver = defaultCssVariablesResolver(theme);
  const providerGenerator = generator == null ? void 0 : generator(theme);
  return providerGenerator ? deepMerge(defaultResolver, providerGenerator) : defaultResolver;
}

export { getMergedVariables };